var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2030_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66634C2.5 7.12467 2.875 7.49967 3.33333 7.49967C3.79167 7.49967 4.16667 7.12467 4.16667 6.66634V4.99967H5.83333C6.29167 4.99967 6.66667 4.62467 6.66667 4.16634C6.66667 3.70801 6.29167 3.33301 5.83333 3.33301H4.16667V1.66634C4.16667 1.20801 3.79167 0.833008 3.33333 0.833008C2.875 0.833008 2.5 1.20801 2.5 1.66634V3.33301H0.833333C0.375 3.33301 0 3.70801 0 4.16634C0 4.62467 0.375 4.99967 0.833333 4.99967H2.5V6.66634Z",
    fill: "#001F06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 14.167C12.2137 14.167 13.333 13.0477 13.333 11.667C13.333 10.2863 12.2137 9.16699 10.833 9.16699C9.4523 9.16699 8.33301 10.2863 8.33301 11.667C8.33301 13.0477 9.4523 14.167 10.833 14.167Z",
    fill: "#001F06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.99967H14.8583L13.825 3.87467C13.5167 3.53301 13.0667 3.33301 12.6 3.33301H7.26667C7.40833 3.58301 7.5 3.85801 7.5 4.16634C7.5 5.08301 6.75 5.83301 5.83333 5.83301H5V6.66634C5 7.58301 4.25 8.33301 3.33333 8.33301C3.025 8.33301 2.75 8.24134 2.5 8.09967V16.6663C2.5 17.583 3.25 18.333 4.16667 18.333H17.5C18.4167 18.333 19.1667 17.583 19.1667 16.6663V6.66634C19.1667 5.74967 18.4167 4.99967 17.5 4.99967ZM10.8333 15.833C8.53333 15.833 6.66667 13.9663 6.66667 11.6663C6.66667 9.36634 8.53333 7.49967 10.8333 7.49967C13.1333 7.49967 15 9.36634 15 11.6663C15 13.9663 13.1333 15.833 10.8333 15.833Z",
    fill: "#001F06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2030_6003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAPhoto);
export default __webpack_public_path__ + "static/media/add_a_photo.5f7f69cf650f6b7b0324b01d57d2e53d.svg";
export { ForwardRef as ReactComponent };